import styled, { css } from 'styled-components/macro';

import { IRoiTextProps } from '@domain/interfaces/dashboard/AdsManager/Table/Content/IRoi';

import TextBase from '@components/common/core/DataDisplay/Text';

export const TotalLabel = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[2]};
  line-height: 120%;
  white-space: nowrap;
`;

export const ForeCastAmount = styled(TextBase)<IRoiTextProps>`
  font-size: 0.875rem;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.success.default};
  display: flex;
  align-items: center;
  gap: 4px;

  ${({ amount, theme }) =>
    amount === 0 &&
    css`
      color: ${theme.colors.gray[1]};
    `};

  ${({ amount, theme }) =>
    amount < 0 &&
    css`
      color: ${theme.colors.danger.default};
    `};
`;

export const AverageAmountText = styled(TextBase)<IRoiTextProps>`
  line-height: 120%;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.success.default};

  ${({ amount, theme }) =>
    amount === 0 &&
    css`
      color: ${theme.colors.gray[1]};
    `};

  ${({ amount, theme }) =>
    amount < 0 &&
    css`
      color: ${theme.colors.danger.default};
    `};
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;
  overflow: hidden;
`;
